import { PropsWithChildren } from 'preact/compat';
import useSetupAppInsights from '../../hooks/use-setup-app-insights';
import useAxiosInterceptors from '../../hooks/use-axios-interceptors';
import useApplyMaximumScale from '../../hooks/use-apply-maximum-scale';

const BootstrapApp = ({ children }: PropsWithChildren) => {
    useSetupAppInsights();
    useApplyMaximumScale('iPhone', 1);

    const isInterceptorsSet = useAxiosInterceptors();

    return <>{isInterceptorsSet && children}</>;
};

export default BootstrapApp;
